import TeamSection from "./TeamSection";

export default TeamSection;
